export default __webpack_public_path__ + "static/media/logo192.5d66c2c7.png";